var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Typography as RmwcTypography } from '@rmwc/typography';
import { RMWCProvider } from '@rmwc/provider';
/**
 * Typography component. Material Design’s text sizes and styles.
 *
 *  **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/typography.md
 */
export default function Typography(props) {
    return (React.createElement(RMWCProvider, { typography: {
            headline1: 'h1',
            headline2: 'h2',
            headline3: 'h3',
            headline4: 'h4',
            headline5: 'h5',
            headline6: 'h6',
        } },
        React.createElement(RmwcTypography, __assign({}, props))));
}
//# sourceMappingURL=Typography.js.map